import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import useAxios from "../../../../hooks/useAxios";
import "./CreateClassModal.css";
import StyledTextField from "../../../common/StyledComponents/StyledTextField";
import { useNavigate } from "react-router-dom";

const CreateClassModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  const [className, setClassName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isMissingProfile, setIsMissingProfile] = useState(false);
  const axiosInstance = useAxios();

  const handleCloseModal = () => {
    setClassName("");
    setDescription("");
    setError(null);
    setIsMissingProfile(false);
    onClose();
  }

  const handleCreateClass = async () => {
    setError(null);
    setLoading(true);
  
    try {
      const response = await axiosInstance.post("/classes/create", {
        class_name: className,
        description,
      });
  
      if (response.data.success) {
        // Reset fields and close modal
        setClassName("");
        setDescription("");
        onClose();
      } else {
        setError(response.data.message || "Failed to create class.");
      }
    } catch (err) {
      const errorCode = err.response?.data?.error_code;
  
      if (errorCode === "MISSING_PROFILE") {
        setIsMissingProfile(true);  // Show button to navigate to complete profile page
      }
  
      setError(err.response?.data?.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="create-class-modal-title"
      aria-describedby="create-class-modal-description"
    >
      <Box className="create-class-modal-container">
        <Typography variant="h5" className="create-class-modal-title">
          Create a New Class
        </Typography>
        <StyledTextField
          label="Class Name"
          name="class_name"
          value={className}
          onChange={(e) => setClassName(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <StyledTextField
          label="Description"
          name="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
          margin="normal"
          multiline
          rows={4}
        />

        {error && (
          <Typography variant="body2" color="error" className="error-message">
            {error}
          </Typography>
        )}
        {isMissingProfile && (
          <Button
          className="my-3"
          onClick={() => {navigate('/setup-profile')}}
          >
              Complete your profile now
          </Button>
        )
        }

        <Button
          onClick={handleCreateClass}
          className="create-class-button primary-button"
          disabled={loading || !className.trim()}
        >
          {loading ? <CircularProgress size={24} /> : "Create Class"}
        </Button>
      </Box>
    </Modal>
  );
};

export default CreateClassModal;
